<template>
    <form class="form-light flex overflow-hidden flex-col" @enter.prevent>
        <div v-if="success || errorMessage"
             class="relative bg-white rounded-2xl border-2 min-h-38 px-5 pt-13 pb-7 -mx-5 mt-20 mb-12 lg:mt-15 lg:pl-18 lg:pr-8 lg:py-9 lg:mr-0 lg:ml-13"
             :class="errorMessage ? 'border-red' : 'border-green'">
            <div class="text-white absolute left-1/2 -top-7 -translate-x-1/2 flex justify-center items-center w-14 h-14 transform rotate-45 rounded-mid
                                lg:-left-11 lg:top-1/2 lg:w-22 lg:h-22 lg:translate-x-0 lg:-translate-y-1/2 lg:rounded-3xl"
                 :class="errorMessage ? 'bg-red' : 'bg-green'">
                <icon :name="errorMessage ? 'close' : 'check'" class="fill-current w-6 h-6 transform -rotate-45" />
            </div>
            <slot v-if="errorMessage" name="error"/>
            <slot v-else name="thankyou"/>
        </div>
        <template v-else>
            <div>
                <div>
                    <div class="grid gap-x-4 gap-y-8 lg:grid-cols-2">
                        <slot/>
                    </div>
                    <div class="my-6 lg:w-3/4">
                        <slot name="privacy" :toggle="toggle"/>
                    </div>
                </div>
                <div class="my-8 lg:col-span-8 lg:col-start-2">
                    <div class="flex mb-4">
                        <div class="group flex lg:justify-end cursor-pointe">
                            <button class="button group-hover:bg-dark-red"
                                    type="submit"
                                    id="submit-form"
                                    @click.prevent="submit">
                                {{ submitLabel }}
                            </button>
                            <button class="button -ml-px py-3 group-hover:bg-dark-red"
                                    type="submit"
                                    @click.prevent="submit">
                                <icon name="mail" class="stroke-current w-4 h-4 mx-px lg:group-hover:animate-bounce"/>
                            </button>
                        </div>
                    </div>
                    <div class="form-prose">
                        <slot name="privacynotice"/>
                    </div>
                </div>
            </div>
        </template>
    </form>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import axios from 'axios';

const FORM_ENDPOINT = '/.rest/api/v2/form/service';

@Component
export default class ServiceForm extends Vue {
    @Prop({ required: true }) backLabel: string;
    @Prop({ required: true }) submitLabel: string;
    @Prop({ required: true }) serverError: string;

    success = false;
    checked = false;
    loading = false;
    errorMessage = '';

    async submit({ target }) {
        this.errorMessage = '';
        this.loading = true;
        const form: HTMLFormElement = target.form;
        const fd: FormData = new FormData(form);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const encodedFd: URLSearchParams = new URLSearchParams(fd as any); // this works but type checking fails without `any`

        try {
            if (form.checkValidity()) {
                const res = await axios({
                    method: 'post',
                    url: `${this.$contextPath}${FORM_ENDPOINT}/${this.$site}/${this.$lang}`,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    data: encodedFd
                });
                if (res.data.success) {
                    this.success = true;
                } else {
                    this.errorMessage = this.serverError;
                }
                this.loading = false;
            } else {
                for (let i = 0; i < form.elements.length; i++) {
                    // trigger custom validation messages
                    (form.elements[i] as HTMLFormElement).dataset.touched = '';
                    this.loading = false;
                }
            }
        } catch (err) {
            this.errorMessage = this.serverError;
            this.loading = false;
        }

        // scroll to top of section
        let section: HTMLElement = form.offsetParent as HTMLElement;
        while (section.tagName.toLowerCase() !== 'section') {
            section = section.offsetParent as HTMLElement;
        }
        window.scrollTo({ top: section.offsetTop, behavior: 'smooth' });
    }

    toggle() {
        this.checked = !this.checked;
    }
}
</script>
